// extracted by mini-css-extract-plugin
export default {"addRecipeWrapper":"G7893b7","dropperContainer":"G82632b G579119"};